import { useEffect, useMemo } from 'react'
import { useQuery } from 'react-query'

import { getVouchersStatusesAPI } from 'api/vouchers'
import { useVouchersStatusesStore } from 'store/vouchers'
import { DropDownItem } from 'types/components'

import { DATASTATUS } from 'constants/status'

export const useMemberVouchersStatuses = ({ voucherCurrentStatus }: { voucherCurrentStatus: string }) => {

  const vouchersStatusesModStatus = useVouchersStatusesStore(
    (state) => state.vouchersStatusesModStatus
  )
  const vouchersStatusesModStatusSet = useVouchersStatusesStore(
    (state) => state.vouchersStatusesModStatusSet
  )
  const vouchersStatusesModErrors = useVouchersStatusesStore(
    (state) => state.vouchersStatusesModErrors
  )
  const vouchersStatusesModErrorsSet = useVouchersStatusesStore(
    (state) => state.vouchersStatusesModErrorsSet
  )
  const vouchersStatuses = useVouchersStatusesStore(
    (state) => state.vouchersStatuses
  )
  const vouchersStatusesSet = useVouchersStatusesStore(
    (state) => state.vouchersStatusesSet
  )

  const {
    data: dataVouchers,
    isLoading: isLoadingVouchers,
    isError: isErrorVouchers,
  } = useQuery({
    refetchOnWindowFocus: false,
    queryKey: ['useVouchersStatuses'],
    queryFn: async () => {
      try {
        vouchersStatusesModStatusSet('loading')
        const response = await getVouchersStatusesAPI()
        if (response.outcomeCode === DATASTATUS.outcomeCode) throw response
        vouchersStatusesModStatusSet('success')
        return response
      } catch (e) {
        vouchersStatusesModStatusSet('fail')
        vouchersStatusesModErrorsSet(JSON.stringify(e))
      }
    },
  })

  useEffect(() => {
    if (dataVouchers)
      vouchersStatusesSet(dataVouchers.vouchersStatus)
  }, [dataVouchers, vouchersStatusesSet])

  const vouchersStatusesOptions: DropDownItem[] = useMemo(() => {
    // Only allow status changes for ACTIVE vouchers
    if (voucherCurrentStatus.toUpperCase() === 'ACTIVE') {
      return vouchersStatuses
        .filter((item) => item.value === '2') // Only show Cancelled option
        .map((item) => ({
          label: 'Cancelled',
          value: String(item.value),
        }))
    }
    return []
  }, [vouchersStatuses, voucherCurrentStatus])

  return {
    memberVouchersStatusesOptions: vouchersStatusesOptions,
    memberVouchersStatuses: vouchersStatuses,
    memberVouchersStatusesModStatus: vouchersStatusesModStatus,
  }
}
